import R from 'ramda';
import { APP_ERROR, APP_DATA_LOADED } from './applicationActions';

const initialState = {
  error: {},
  project: {},
  organization: {},
};

const errorLens = R.lensProp('error');
const setError = R.set(errorLens);
export const getError = R.view(errorLens);

const projectLens = R.lensProp('project');
const setProject = R.set(projectLens);
export const getProject = R.view(projectLens);

const organizationLens = R.lensProp('organization');
const setOrganization = R.set(organizationLens);
export const getOrganization = R.view(organizationLens);

const appDataLoaded = R.curry(({ project, organization }, state) =>
  R.pipe(setProject(project), setOrganization(organization))(state),
);

const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_ERROR:
      return setError(action.error, state);

    case APP_DATA_LOADED:
      return appDataLoaded(action.data, state);

    default:
      return state;
  }
};

export default applicationReducer;



// WEBPACK FOOTER //
// ./src/application/applicationReducer.js